<ng-container>

  @if (context == 'survey-team') {
  <form class="team-member-flex-container team-member-inline-form" #surveyTeamForm="ngForm"
    (keydown.enter)="$event.preventDefault()" novalidate (ngSubmit)="addSurveyTeamMember(surveyTeamForm)">

    <div class="tm-row">
      <div class="field-group flex-grow-1">
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100 mb-0">
          <mat-label>{{ 'generic.name' | translate }}</mat-label>
          <input matInput name="survey_team_member_name" [(ngModel)]="teamMember.name" [ngModelOptions]="{standalone: true}"
            placeholder="{{ 'generic.name' | translate }}" autocomplete="off" autocorrect="off" autocapitalize="off"
            spellcheck="false" required />
        </mat-form-field>
      </div>

      <div class="field-group flex-grow-1">
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100 mb-0">
          <mat-label>{{ 'generic.surname' | translate }}</mat-label>
          <input matInput name="survey_team_member_last_name" [(ngModel)]="teamMember.last_name" [ngModelOptions]="{standalone: true}"
            placeholder="{{ 'generic.surname' | translate }}" autocomplete="off" autocorrect="off" autocapitalize="off"
            spellcheck="false" required />
        </mat-form-field>
      </div>
      <div class="field-group flex-grow-1">
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100 mb-0">
          <mat-label>{{ 'generic.phone' | translate }}</mat-label>
          <input matInput name="survey_team_member_phone" [(ngModel)]="teamMember.customs.phone_number" [ngModelOptions]="{standalone: true}"
            placeholder="{{ 'generic.phone' | translate }}" />
        </mat-form-field>
      </div>
    </div>

    <div class="tm-row">
      <div class="field-group tm-col-6" (click)="onClickSearchUser(teamMember)">
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100 mb-0">
          <mat-label>{{ 'generic.email' | translate }}</mat-label>
          <input type="email" matInput name="survey_team_member_email" [value]="teamMember.email" autocomplete="false"
            (input)="onInputSearchUserChange($event.target.value, teamMember)"
            placeholder="{{ 'generic.email' | translate }}" [matAutocomplete]="auto" autocomplete="off"
            autocorrect="off" autocapitalize="off" spellcheck="false" required>
          <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn"
            (optionSelected)="setUserInfoByEmail($event, teamMember)">
            @for (option of suggestedTeamMemberUsers; track option) {
            <mat-option [value]="option">
              {{option.email}}
            </mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
      </div>

      <div class="field-group tm-col-3">
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100 mb-0">
          <mat-label>{{ 'generic.roles.role' | translate }}</mat-label>
          <mat-select name="survey_team_member_role" [(ngModel)]="teamMember.role" [ngModelOptions]="{standalone: true}"
            (ngModelChange)="onRoleChange($event, teamMember)" placeholder="{{ 'generic.roles.role' | translate }}">
            <mat-option value=""><em>Nessuno</em></mat-option>
            <mat-option value="EDITOR">Editor</mat-option>
            <mat-option value="VIEWER">Viewer</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="field-group tm-col-3">
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100 mb-0">
          <mat-label>{{ 'generic.is-respondent' | translate }}</mat-label>
          <mat-select name="survey_team_member_is_respondent" [(ngModel)]="teamMember.is_respondent" [ngModelOptions]="{standalone: true}"
            [disabled]="!teamMember.role">
            <mat-option [value]="true">{{ 'generic.yes' | translate }}</mat-option>
            <mat-option [value]="false">{{ 'generic.no' | translate }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>


    </div>

    <div class="tm-row mt-2 gap-2 flex-wrap">
      @for (field of teamMemberCustomFields; track field.id) {
      <div class="field-group flex-grow-1" style="min-width: 150px;">
        @if (field.type === 'boolean') {
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100">
          <mat-label>{{ field.name }}</mat-label>
          <i matPrefix class="fa-solid pr-2" [ngClass]="getCustomFieldIcon(field.type)"></i>
          <mat-select [name]="'cf_add_' + field.id" [(ngModel)]="teamMember.customs.team_member_custom_fields[field.id]" [ngModelOptions]="{standalone: true}">
            <mat-option [value]="true">{{ 'generic.yes' | translate }}</mat-option>
            <mat-option [value]="false">{{ 'generic.no' | translate }}</mat-option>
          </mat-select>
        </mat-form-field>
        } @else if (field.type === 'date') {
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100">
          <mat-label>{{ field.name }}</mat-label>
          <i matPrefix class="fa-solid pr-2" [ngClass]="getCustomFieldIcon(field.type)"></i>
          <input matInput [matDatepicker]="pickerFieldAdd" [name]="'cf_add_' + field.id"
            [(ngModel)]="teamMember.customs.team_member_custom_fields[field.id]" [ngModelOptions]="{standalone: true}" [placeholder]="field.name">
          <mat-datepicker-toggle matSuffix [for]="pickerFieldAdd"></mat-datepicker-toggle>
          <mat-datepicker #pickerFieldAdd></mat-datepicker>
          <mat-hint>DD/MM/YYYY</mat-hint>
        </mat-form-field>
        } @else {
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100">
          <mat-label>{{ field.name }}</mat-label>
          <i matPrefix class="fa-solid pr-2" [ngClass]="getCustomFieldIcon(field.type)"></i>
          <input matInput [type]="field.type === 'number' ? 'number' : 'text'" [name]="'cf_add_' + field.id"
            [(ngModel)]="teamMember.customs.team_member_custom_fields[field.id]" [ngModelOptions]="{standalone: true}" [placeholder]="field.name">
        </mat-form-field>
        }
      </div>
      }
    </div>

    @if (addButton) {
    <div class="tm-row">
      <div class="field-group action-group flex-grow-1">
        <button type="submit" matButton="filled" color="primary" class="add-btn w-100">
          <mat-icon>add</mat-icon> {{'generic.buttons.add' | translate}}
        </button>
      </div>
    </div>
    }
  </form>
  } @else {
  <div class="team-member-flex-container team-member-card">
    <div class="tm-row">
      <div class="field-group flex-grow-1">
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100 mb-0">
          <mat-label>{{ 'generic.name' | translate }}</mat-label>
          <input matInput name="team_member_name" [(ngModel)]="team_member.name" [ngModelOptions]="{standalone: true}"
            placeholder="{{ 'generic.name' | translate }}" required />
        </mat-form-field>
      </div>

      <div class="field-group flex-grow-1">
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100 mb-0">
          <mat-label>{{ 'generic.surname' | translate }}</mat-label>
          <input matInput name="team_member_last_name" [(ngModel)]="team_member.last_name" [ngModelOptions]="{standalone: true}"
            placeholder="{{ 'generic.surname' | translate }}" required />
        </mat-form-field>
      </div>
      <div class="field-group flex-grow-1">
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100 mb-0">
          <mat-label>{{ 'generic.phone' | translate }}</mat-label>
          <input matInput name="team_member_phone" [(ngModel)]="team_member.customs.phone_number" [ngModelOptions]="{standalone: true}"
            placeholder="{{ 'generic.phone' | translate }}" />
        </mat-form-field>
      </div>
    </div>

    <div class="tm-row">
      <div class="field-group tm-col-6" (click)="onClickSearchUser(team_member)">
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100 mb-0">
          <mat-label>{{ 'generic.email' | translate }}</mat-label>
          <input type="email" matInput name="team_member_email" [value]="team_member.email" autocomplete="false"
            (input)="onInputSearchUserChange($event.target.value, team_member)"
            placeholder="{{ 'generic.email' | translate }}" [matAutocomplete]="auto_else" required>
          <mat-autocomplete #auto_else="matAutocomplete" [displayWith]="displayFn"
            (optionSelected)="setUserInfoByEmail($event, team_member)">
            @for (option of suggestedTeamMemberUsers; track option) {
            <mat-option [value]="option">
              {{option.email}}
            </mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
      </div>

      <div class="field-group tm-col-3">
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100 mb-0">
          <mat-label>{{ 'generic.roles.role' | translate }}</mat-label>
          <mat-select
            [disabled]="team_member?.role === 'OWNER'"
            name="team_member_role"
            [(ngModel)]="team_member.role"
            [ngModelOptions]="{standalone: true}"
            (ngModelChange)="onRoleChange($event, team_member)"
            placeholder="{{ 'generic.roles.role' | translate }}">
            @if (team_member?.role === 'OWNER') {
              <mat-option value="OWNER" disabled>Owner</mat-option>
            }
            <mat-option value=""><em>Nessuno</em></mat-option>
            <mat-option value="EDITOR">Editor</mat-option>
            <mat-option value="VIEWER">Viewer</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="field-group tm-col-3">
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100 mb-0">
          <mat-label>{{ 'generic.is-respondent' | translate }}</mat-label>
          <mat-select name="team_member_is_respondent" [(ngModel)]="team_member.is_respondent" [ngModelOptions]="{standalone: true}"
            [disabled]="!team_member.role">
            <mat-option [value]="true">{{ 'generic.yes' | translate }}</mat-option>
            <mat-option [value]="false">{{ 'generic.no' | translate }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div class="tm-row mt-2 gap-2 flex-wrap">
      @for (field of teamMemberCustomFields; track field.id) {
      <div class="field-group flex-grow-1" style="min-width: 150px;">
        @if (field.type === 'boolean') {
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100">
          <mat-label>{{ field.name }}</mat-label>
          <i matPrefix class="fa-solid pr-2" [ngClass]="getCustomFieldIcon(field.type)"></i>
          <mat-select [name]="'cf_edit_' + field.id" [(ngModel)]="team_member.customs.team_member_custom_fields[field.id]" [ngModelOptions]="{standalone: true}">
            <mat-option [value]="true">{{ 'generic.yes' | translate }}</mat-option>
            <mat-option [value]="false">{{ 'generic.no' | translate }}</mat-option>
          </mat-select>
        </mat-form-field>
        } @else if (field.type === 'date') {
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100">
          <mat-label>{{ field.name }}</mat-label>
          <i matPrefix class="fa-solid pr-2" [ngClass]="getCustomFieldIcon(field.type)"></i>
          <input matInput [matDatepicker]="pickerFieldEdit" [name]="'cf_edit_' + field.id"
            [(ngModel)]="team_member.customs.team_member_custom_fields[field.id]" [ngModelOptions]="{standalone: true}" [placeholder]="field.name">
          <mat-datepicker-toggle matSuffix [for]="pickerFieldEdit"></mat-datepicker-toggle>
          <mat-datepicker #pickerFieldEdit></mat-datepicker>
          <mat-hint>DD/MM/YYYY</mat-hint>
        </mat-form-field>
        } @else {
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100">
          <mat-label>{{ field.name }}</mat-label>
          <i matPrefix class="fa-solid pr-2" [ngClass]="getCustomFieldIcon(field.type)"></i>
          <input matInput [type]="field.type === 'number' ? 'number' : 'text'" [name]="'cf_edit_' + field.id"
            [(ngModel)]="team_member.customs.team_member_custom_fields[field.id]" [ngModelOptions]="{standalone: true}" [placeholder]="field.name">
        </mat-form-field>
        }
      </div>
      }
    </div>

    @if (mode === 'edit') {
      <div class="tm-row justify-content-end gap-3 mt-4 edit-actions">
        @if (removable) {
          <button mat-icon-button color="warn" (click)="removeTeamMember()" class="delete-btn"
            matTooltip="{{ 'generic.remove' | translate }}">
            <mat-icon>delete_outline</mat-icon>
          </button>
        }
        <button mat-stroked-button type="button" (click)="cancel()">
          {{ 'generic.cancel' | translate }}
        </button>
        <button mat-flat-button color="primary" type="button" (click)="save()" [disabled]="loading">
          @if (loading) {
            <mat-spinner diameter="20" class="mr-2"></mat-spinner>
          }
          {{ 'generic.buttons.save' | translate }}
        </button>
      </div>
    } @else {
      <div class="tm-row justify-content-end mt-3">
        @if (removable) {
          <button mat-icon-button color="warn" (click)="removeTeamMember()" class="delete-btn"
            matTooltip="{{ 'generic.delete' | translate }}">
            <mat-icon>delete_outline</mat-icon>
          </button>
        }
      </div>
    }
  </div>
  @if (false) {
  <mat-form-field class="select-primary col-6 col-md-3" appearance="fill">
    <mat-label>{{
      "generic.roles.professional-role" | translate
      }}</mat-label>
    <mat-select name="team_member_professional_role" [(ngModel)]="
                            team_member.organization_professional_role_id
                          ">
      <mat-option value="" selected></mat-option>
      @for (professionalRole of professionalRoles; track professionalRole) {
      <mat-option [value]="professionalRole.id">{{ professionalRole.role }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
  }
  @if (process_role_field) {
  <mat-form-field class="select-primary col-4" appearance="fill">
    <mat-label>{{
      "generic.roles.process-role" | translate
      }}</mat-label>
    <mat-select name="team_member_process_role" [(ngModel)]="team_member.process_role" required [ngModelOptions]="{standalone: true}">
      <mat-option value="" selected></mat-option>
      @for (processRole of process_roles; track processRole) {
      <mat-option [value]="processRole.key">{{
        processRolesService.getProcessRolesValueByKey(
        processRole.key
        )
        }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
  }
  @if (false) {
  <mat-form-field class="select-primary col-3 col-md-2" appearance="fill">
    <mat-label>{{
      "generic.weight" | translate
      }}</mat-label>
    <mat-select name="team_member_weight" [(ngModel)]="team_member.weight" [ngModelOptions]="{standalone: true}">
      <mat-option value=""></mat-option>
      <mat-option [value]="100">100</mat-option>
    </mat-select>
  </mat-form-field>
  }
  }
  @if (process_role_field && false) {
  <!-- the rest of the old form fields disabled -->
  }
</ng-container>

@if (team_member?.imported_by_organization_chart_id) {
<span class="text-center mt-4 col-12 main-color">
  {{ 'generic.imported-by' | translate }} "{{
  getOrganizationChart(team_member?.imported_by_organization_chart_id)?.title }}"
</span>
}
